import { render, staticRenderFns } from "./dispatch_board_tbn.vue?vue&type=template&id=9725796a&scoped=true&"
import script from "./dispatch_board_tbn.vue?vue&type=script&lang=js&"
export * from "./dispatch_board_tbn.vue?vue&type=script&lang=js&"
import style0 from "./dispatch_board_tbn.vue?vue&type=style&index=0&id=9725796a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9725796a",
  null
  
)

export default component.exports